import { deleteQualityQuestion } from "api/Settings";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useDeleteQualityQuestion = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteQualityQuestion, {
        onSuccess: () => {
            queryClient.invalidateQueries('quality-questions');

            toast.success("Deleted Successfully");
        },
        onError: (error: any) => {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
                return;
            }
            if (error?.response?.data?.error) {
                toast.error(error?.response?.data?.error);
                return;
            }
            toast.error(`Something went wrong`);
        },
    });
};
